(function () {
  'use strict';

  /* @ngdoc object
   * @name usuaris.main
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main', [
      'ui.router',
      'itecAdministracio.usuaris.main.llista',
      'itecAdministracio.usuaris.main.submain.dades',
      'itecAdministracio.usuaris.main.submain.edit'
    ]);
}());
